<template>
    <div>
        <div class="row mb-2">
            <div class="col-auto">
                <h4>Aggiungi nuova domanda</h4>
            </div>
        </div>
        <div class="row">
            <b-form-group
                class="col-auto"
                label="Titolo"
                label-for="new-title">
                <b-input v-model="title" id="new-title" type="text" class="form-control" placeholder="Nome" />
            </b-form-group>
            <b-form-group
                class="col"
                label="Risposte"
                label-for="new-answers">
                <b-tags id="new-answers" v-model="answers"></b-tags>
            </b-form-group>
            <div class="col-auto d-flex flex-column justify-content-end mb-3">
                <b-button @click.prevent="add" variant="primary">Aggiungi</b-button>
            </div>
        </div>
        <hr />
    </div>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "AddQuizQuestion",
    props: {
        eventId: Number,
    },
    data() {
        return {
            title: '',
            answers: [],
        }
    },
    methods: {
        add() {
            this.$apollo.mutate({
                mutation: gql`mutation ($eventId: ID!, $title: String!, $answers: JSON!) {
                    addQuizQuestion(eventId: $eventId, title: $title, answers: $answers) {
                        id
                    }
                }`,
                variables: {
                    eventId: this.eventId,
                    title: this.title,
                    answers: JSON.stringify(this.answers),
                },
                refetchQueries: [
                    'GetQuizQuestions'
                ]
            }).then((data) => {
                this.title = '';
                this.answers = [];
            }).catch((error) => {
                console.log(error)
            })
        }
    }
}
</script>

<style scoped>

</style>
